import React from "react";
import Slider from "react-slick";

const devTools = [
    {
        id: 1,
        image: "images/tools/bootstrap.jpg",
        name: "Bootstrap",
    },
    {
        id: 2,
        image: "images/tools/git.jpg",
        name: "Git",
    },
    {
        id: 3,
        image: "images/tools/javascript.jpg",
        name: "Vanilla JavaScript",
    },
    {
        id: 4,
        image: "images/tools/react.jpg",
        name: "React.Js",
    },
    {
        id: 5,
        image: "images/tools/redux.jpg",
        name: "Redux",
    },
    {
        id: 6,
        image: "images/tools/nextjs.jpg",
        name: "Next.Js",
    },
    {
        id: 7,
        image: "images/tools/typescript.jpg",
        name: "Typescript",
    },
    {
        id: 8,
        image: "images/tools/jquery.jpg",
        name: "JQuery",
    },
    {
        id: 9,
        image: "images/tools/laravel.jpg",
        name: "Laravel",
    },
    {
        id: 10,
        image: "images/tools/php.jpg",
        name: "PHP",
    },
    {
        id: 11,
        image: "images/tools/sql.jpg",
        name: "SQL(MySQL)",
    },
];

function Tools() {
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };
    return (
        <section className="shadow-dark background-white color-white padding-50">
            <h2 className="d-none">Tools</h2>

            <div className="clients-wrapper">
                <Slider {...settings} className="padding-slider">
                    {devTools.map((tool) => (
                        <div className="client-item" key={tool.id}>
                            <div className="inner">
                                <img src={tool.image} alt={tool.name} className="height-60" />
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
}

export default Tools;
